import React from "react";
import "../../styles/Home.css";

export default function EmptyUserCard({
  platform,
  icon: Icon,
  title,
  description,
  buttonText,
  onLogin,
  buttonStyle,
}) {
  return (
    <div className="card fade-in empty-card">
      <div className="empty-card-icon">
        <Icon />
      </div>
      <h3 className="empty-card-title">{title}</h3>
      <p className="empty-card-description">{description}</p>
      <button
        className="button empty-card-btn"
        onClick={onLogin}
        style={buttonStyle}
      >
        {buttonText}
      </button>
    </div>
  );
}

